import { render, staticRenderFns } from "./GeneralRequirementsAdmin.vue?vue&type=template&id=04ab60f0&scoped=true"
import script from "./GeneralRequirementsAdmin.vue?vue&type=script&lang=js"
export * from "./GeneralRequirementsAdmin.vue?vue&type=script&lang=js"
import style0 from "./GeneralRequirementsAdmin.vue?vue&type=style&index=0&id=04ab60f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab60f0",
  null
  
)

export default component.exports